// 商品加工状态枚举
export const SKU_TYPE = {
    finishedEnum: 1, // 成品
    materialEnum: 2, // 原料
    processedEnum: 3, // 加工品
};

// 库存类型枚举
export const STOCK_TYPE = {
    selfEnum: 0, // 独立库存
    shareEnum: 1, // 共享库存
};

export const LINE_TYPE_NAMES = {
    1: '所有产线通用',
    2: '仅手工加工使用',
    3: '仅机器加工使用',
};

// 是否核心配料
export const CoreIngredientList = [
    {
        label: '是',
        value: 1,
    },
    {
        label: '否',
        value: 2,
    },
];
// 扩展属性类型
export const ExtBusinessTypeMap = {
    BASE_INFO: 1, // 基础属性
    SALE_SPEC: 2, // 销售规格
    CITY_SALE: 3, // 城市售卖属性
    CITY_PURCHASE: 4, // 城市采购属性
    OPERATE: 5, // 运营内容属性
};

export const mockData = {
    applyInfoSection: {
        spuBaseId: 1021084,
        categoryId: 302,
        categoryName: '西瓜',
        spuName: 'wcs测试新品提报10',
        brandId: 9674,
        brandName: '.无',
        skuBaseId: 0,
        spec: 'g',
        specActual: 'g',
        taste: '',
        skuName: 'ceshia',
        citySku: [{
            cityId: 351, fdcGroups: [31], planOnSaleTime: 1647324508565, skuType: 1, exist: false,
        }, {
            cityId: 417, fdcGroups: [32], planOnSaleTime: 1647324509556, skuType: 1, exist: false,
        }],
        applyReason: 1,
        applyDetail: '',
        keyAttributes: [],
        skuDisable: false,
        bgCategoryId: 4001858,
        bgCategoryName: '测试333',
        bgCategoryNamePath: '包材1>测试333',
        categoryNamePath: '生鲜01>水果>瓜果类>西瓜',
    },
    skuBaseSection: null,
    citySkuManageSection: null,
    qualificationSection: null,
    flowId: 0,
    completeSectionStage: 3,
    complete: true,
    rejectNodes: '',
    contentSection: null,
    presetSkuId: 1017110,
};

// 实物图信息核对场景 1供应商建品 2采购上新编辑提交 3上新详情页审核 4商品基础属性详情页修改提交 5商品基础属性修改详情页审核 6采购商品内容信息编辑 7供应商商品内容信息编辑 8商品内容信息审核 9上新品控审核 10城市保质期编辑 11城市保质期审核 12 供应商建品保存草稿 13 采购建品保存草稿
export const VALID_CODE_SENSE = {
    SUPPLIER_CREATE: 1,
    PURCHASE_NEW_EDIT: 2,
    SUPPLIER_CREATE_SAVE: 12,
    PURCHASE_CREATE: 13,
};

export const CREATE_NEW_PRODUCT_STEP = {
    CREATE_INFO: 0,
    PRODUCT_BASE_INFO: 1,
    CITY_SALES_INFO: 2,
    SUPPLIER_INFO: 3,
    OPERATE_INFO: 4,
};

export const CREATE_NEW_PRODUCT_STEP_NAMES = {
    [CREATE_NEW_PRODUCT_STEP.CREATE_INFO]: '提报信息',
    [CREATE_NEW_PRODUCT_STEP.PRODUCT_BASE_INFO]: '商品基础信息',
    [CREATE_NEW_PRODUCT_STEP.CITY_SALES_INFO]: '城市经营信息',
    [CREATE_NEW_PRODUCT_STEP.SUPPLIER_INFO]: '供应商信息',
    [CREATE_NEW_PRODUCT_STEP.OPERATE_INFO]: '内容信息',
};

// 属性禁用
export const attrDisabledMap = {
    // 资质认证
    QUALIFICATION_CERTIFICATION: 64,
    // 称重加工下浮范围
    WEIGHT_PROCESSING_DOWNWARD_RANGE: 152,
};
